import {ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, OnChanges, Output} from '@angular/core';
import {Direction} from '../../enums/direction.enum';

/**
 * Кнопка для отображения состояния сортировки
 */

@Component({
    selector: 'app-sortby-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: '<span><ng-content></ng-content></span>{{arrow}}',
    styles: [`
        :host {
            cursor: pointer;
            border-bottom: 1px dashed #9ea0a0;
        }
    `],
})

export class SortbyButtonComponent implements OnChanges {
    @Input() sorted_attribute: string;
    @Input() current_attribute = '';
    @Input() direction = Direction.up;

    @Output() sort = new EventEmitter<string>();

    public arrow: string;

    @HostListener('click')
    onClick() {
        this.sort.emit(this.sorted_attribute);
    }

    ngOnChanges() {
        if ((this.sorted_attribute === this.current_attribute) && this.current_attribute.length) {
            this.arrow = this.direction === Direction.down ? '↓' : '↑';
        } else {
            this.arrow = null;
        }
    }
}
